<template>
  <b-tooltip id="tooltip" :target="target" :placement="placement" :triggers="triggers" :disabled.sync="disabled">
    <span v-html="text" />
  </b-tooltip>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    target: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    text: {
      type: String,
      required: true,
    },
    triggers: {
      type: String,
      default: 'hover',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.tooltip-inner {
  background-color: $grey !important;
  color: white !important;

  a {
    color: white;
    text-decoration: underline;
  }
}
.tooltip.bs-tooltip-right .arrow:before {
  border-right-color: $grey !important;
}
.tooltip.bs-tooltip-left .arrow:before {
  border-left-color: $grey !important;
}
.tooltip.bs-tooltip-bottom .arrow:before {
  border-bottom-color: $grey !important;
}
.tooltip.bs-tooltip-top .arrow:before {
  border-top-color: $grey !important;
}
</style>
